// define([
//     'domvm', 'i18n',
//     'controls-templates',
//     './endpoints/account-endpoint',
//     'lib/ui/module',
//     'lib/data/model/data-validations',
//     'auth-manager'
// ], function (
//     domvm, i18n,
//     ct,
//     accountEndpoint,
//     baseModule,
//     validations,
//     authManager
// ) {

import { Module } from "../../ui/Module.js";
import { i18n } from "../../globalization/i18n.js";
import { emailAddressValidation } from "../../data/model/data-validations.js";
import { Services } from "../../services/Services.js";
import { AccountDataManager } from "./managers/AccountDataManager.js";

export class AccountModule extends Module {

    static MODE_REGISTRATION = 'registration';
    static MODE_REGISTRATION_SUCCESS = 'registration-success';
    static MODE_PASSWORD_RESET_START = 'password-reset-start';
    static MODE_PASSWORD_RESET_START_SUCCESS = 'password-reset-start-success';
    static MODE_PASSWORD_RESET = 'password-reset';
    static MODE_PASSWORD_RESET_SUCCESS = 'password-reset-success';
    static MODE_EMAIL_VERIFICATION = 'email-verification';
    static MODE_EMAIL_VERIFICATION_SUCCESS = 'email-verification-success';
    static MODE_ACCOUNT_DETAILS = 'account-details';

    static ROUTE_REGISTRATION = 'account-registration';
    static ROUTE_REGISTRATION_SUCCESS = 'account-registration-success';
    static ROUTE_PASSWORD_RESET_START = 'account-password-reset-start';
    static ROUTE_PASSWORD_RESET_START_SUCCESS = 'account-password-reset-start-success';
    static ROUTE_PASSWORD_RESET = 'account-password-reset';
    static ROUTE_PASSWORD_RESET_SUCCESS = 'account-password-reset-success';
    static ROUTE_EMAIL_VERIFICATION = 'account-email-verification';
    static ROUTE_EMAIL_VERIFICATION_SUCCESS = 'account-email-verification-success';
    static ROUTE_ACCOUNT_DETAILS = 'account-account-details';

    constructor(app, params = {}) {

        super(app, params);

        this.viewMode = AccountModule.MODE_REGISTRATION;

        this.moduleName = 'AccountModule';
        this.moduleTitle = 'Uživatelský účet';

        this.loginData = this.createLoginData();
        this.registerData = this.createRegisterData();
        this.emailVerificationData = this.createEmailVerificationData();
        this.passwordChangeData = this.createPasswordChangeData();
        this.passwordResetStartData = this.createPasswordResetStartData();
        this.passwordResetData = this.createPasswordResetData();
        this.userData = this.createUserData(this);
        this.accountData = this.createAccountData(this);

        const authManager = Services.get('authManager');
        this.dataManager = new AccountDataManager(authManager);

    };

    // --------------------------------------------------------------------------------------------

    static VIEWMODES_ROUTES = [
        {
            mode: AccountModule.MODE_REGISTRATION,
            route: AccountModule.ROUTE_REGISTRATION,
        },
        {
            mode: AccountModule.MODE_REGISTRATION_SUCCESS,
            route: AccountModule.ROUTE_REGISTRATION_SUCCESS,
            initializer: (module, options, activeRoute) => {

                module.registerData = module.createRegisterData();

            },
        },
        {
            mode: AccountModule.MODE_PASSWORD_RESET_START,
            route: AccountModule.ROUTE_PASSWORD_RESET_START,
            initializer: (module, options, activeRoute) => {

                module.passwordResetStartData = module.createPasswordResetStartData();

            },
        },
        {
            mode: AccountModule.MODE_PASSWORD_RESET_START_SUCCESS,
            route: AccountModule.ROUTE_PASSWORD_RESET_START_SUCCESS,
            initializer: (module, options, activeRoute) => {

                module.passwordResetStartData = module.createPasswordResetStartData();

            },
        },
        {
            mode: AccountModule.MODE_PASSWORD_RESET,
            route: AccountModule.ROUTE_PASSWORD_RESET,
            initializer: (module, options, activeRoute) => {

                const query = activeRoute.query;

                module.passwordResetData = module.createPasswordResetData();
                module.passwordResetData.code = (query && query.code) || null;

            }
        },
        {
            mode: AccountModule.MODE_PASSWORD_RESET_SUCCESS,
            route: AccountModule.ROUTE_PASSWORD_RESET_SUCCESS,
        },
        {
            mode: AccountModule.MODE_EMAIL_VERIFICATION,
            route: AccountModule.ROUTE_EMAIL_VERIFICATION,
            initializer: (module, options, activeRoute) => {

                const query = activeRoute.query;

                module.emailVerificationData = module.createEmailVerificationData();
                module.emailVerificationData.code = (query && query.code) || null;

            },
        },
        {
            mode: AccountModule.MODE_EMAIL_VERIFICATION_SUCCESS,
            route: AccountModule.ROUTE_EMAIL_VERIFICATION_SUCCESS,
            initializer: (module, options, activeRoute) => {

                module.emailVerificationData = module.createEmailVerificationData();

            },
        },
        {
            mode: AccountModule.MODE_ACCOUNT_DETAILS,
            route: AccountModule.ROUTE_ACCOUNT_DETAILS,
        },
    ];

    getRouteDescriptor(route) {

        return AccountModule.VIEWMODES_ROUTES.find((item) => item.route == route);

    };

    getRouteViewMode(route) {

        let found = this.getRouteDescriptor(route);

        if (found)
            return found.mode;

        return AccountModule.MODE_REGISTRATION;

    };

    getViewModeRoute(mode) {

        let found = AccountModule.VIEWMODES_ROUTES.find((item) => item.mode == mode);

        if (found)
            return found.route;

        return 'account-registration';

    };

    getViewModeUrl(mode) {

        return this.getApp().getRouteHash(this.getViewModeRoute(mode));

    };

    // --------------------------------------------------------------------------------------------  

    createLoginData() {

        return {
            username: null,
            password: null,
        };

    };

    createRegisterData() {

        return {
            username: null,
            email: null,
            password: null,
            passwordVerification: null,
            firstName: null,
            lastName: null,
        };

    };

    createEmailVerificationData() {

        return {
            code: null
        };

    };

    createPasswordChangeData() {

        return {
            actualPassword: null,
            password: null,
            passwordVerification: null,
        };

    };

    createPasswordResetStartData() {

        return {
            email: null
        };

    };

    createPasswordResetData() {

        return {
            code: null,
            password: null,
            passwordVerification: null,
        };

    };

    createUserData(module) {

        const authManager = Services.get('authManager');
        const loggedUser = authManager.getUser();

        if (!loggedUser) {
            return {
                username: null,
                email: null,
            };
        }

        return {
            username: loggedUser.username,
            email: loggedUser.email,
        };

    };

    createAccountData(module) {

        const authManager = Services.get('authManager');
        const loggedUser = authManager.getUser();

        if (!loggedUser) {
            return {
                firstName: null,
                lastName: null,
            };
        }

        return {
            firstName: loggedUser.firstName,
            lastName: loggedUser.lastName,
        };

    };

    // --------------------------------------------------------------------------------------------

    isLoginDataValid() {

        let data = this.loginData || {};

        return (data.username && data.password);

    };

    isRegisterDataValid() {

        let data = this.registerData || {};

        return (
            !!data.username
            && !!data.password
            && data.password == data.passwordVerification
            && !!data.email
            && emailAddressValidation.validate(data.email)
        );

    };

    isEmailVerificationDataValid() {

        let data = this.emailVerificationData || {};

        return (
            !!data.code
        );

    };

    isPasswordChangeDataValid() {

        let data = this.passwordChangeData || {};

        return (
            !!data.actualPassword
            && !!data.password
            && !!data.passwordVerification
            && data.password == data.passwordVerification
        );

    };

    isPasswordResetStartDataValid() {

        let data = this.passwordResetStartData || {};

        return (
            !!data.email
            && emailAddressValidation.validate(data.email)
        );

    };

    isPasswordResetDataValid() {

        let data = this.passwordResetData || {};

        return (
            !!data.code
            && !!data.password
            && !!data.passwordVerification
            && data.password == data.passwordVerification
        );

    };

    isAccountDataValid() {

        let data = this.accountData || {};

        return (
            data.$changed
            && !!data.firstName
            && !!data.lastName
        );

    };

    // --------------------------------------------------------------------------------------------  

    async _prepare(options, activeRoute) {

        await super._prepare(options, activeRoute);
        if (options.mode)
            this.viewMode = options.mode;

    };

    async _refresh(options, activeRoute) {

        if (activeRoute.options && activeRoute.options.mode)
            this.viewMode = activeRoute.options.mode;

        const routeDescriptor = this.getRouteDescriptor(activeRoute.def.name);
        if (routeDescriptor) {
            if (routeDescriptor.initializer && typeof routeDescriptor.initializer == 'function') {
                routeDescriptor.initializer(this, options, activeRoute);
            }
        }

        return super._refresh(options, activeRoute);

    };

    // --------------------------------------------------------------------------------------------

    async registerUser() {

        const app = this.getApp();

        app.setBusyFlag();
        try {

            await this.dataManager.registerUser(this.registerData);
            app.routeTo('account-registration-success');

        } catch (error) {

            app.handleError(error);

        } finally {

            app.clearBusyFlag();
            this.invalidate();

        }

    };

    async verifyEmail() {

        const app = this.getApp();

        app.setBusyFlag();
        try {

            await this.dataManager.verifyEmail(this.emailVerificationData)
            this.getApp().routeTo('account-email-verification-success');

        } catch (error) {

            app.handleError(error);

        } finally {

            app.clearBusyFlag();
            this.invalidate();

        }

    };

    async changeDetails() {

        const app = this.getApp();

        app.setBusyFlag();
        try {

            await this.dataManager.changeDetails(this.accountData);

            const authManager = Services.get('authManager');
            await authManager.refreshLoggedUser();

            this.userData = this.createUserData(this);
            this.accountData = this.createAccountData(this);

        } catch (error) {

            app.handleError(error);

        } finally {

            app.clearBusyFlag();
            this.invalidate();

        }

    };

    async changePassword() {

        const app = this.getApp();

        app.setBusyFlag();
        try {

            await this.dataManager.changePassword(this.passwordChangeData);
            this.passwordChangeData = this.createPasswordChangeData();
            this.getApp().showToast('success', i18n.t('module.account.msg_password_changed'));

        } catch (error) {

            app.handleError(error);

        } finally {

            app.clearBusyFlag();
            this.invalidate();

        }

    };

    async startPasswordReset() {

        const app = this.getApp();

        app.setBusyFlag();
        try {

            await this.dataManager.startPasswordReset(this.passwordResetStartData);
            this.passwordResetStartData = this.createPasswordResetStartData();
            this.getApp().routeTo('account-password-reset-start-success');

        } catch (error) {

            app.handleError(error);

        } finally {

            app.clearBusyFlag();
            this.invalidate();

        }

    };

    async resetPassword() {

        const app = this.getApp();

        app.setBusyFlag();
        try {

            await this.dataManager.resetPassword(this.passwordResetData);
            this.viewMode = AccountModule.MODE_PASSWORD_RESET_SUCCESS;
            this.passwordResetData = this.createPasswordResetData();

        } catch (error) {

            app.handleError(error);

        } finally {

            app.clearBusyFlag();
            this.invalidate();

        }

    };

    // --------------------------------------------------------------------------------------------

    _render(vm) {

        const ct = Services.get('templates');
        const module = this;

        let viewNodes = null;

        switch (module.viewMode) {
            case AccountModule.MODE_REGISTRATION_SUCCESS:
                viewNodes = renderRegistrationSuccessView();
                break;
            case AccountModule.MODE_PASSWORD_RESET_START:
                viewNodes = renderPasswordResetStartView();
                break;
            case AccountModule.MODE_PASSWORD_RESET_START_SUCCESS:
                viewNodes = renderPasswordResetStartSuccessView();
                break;
            case AccountModule.MODE_PASSWORD_RESET:
                viewNodes = renderPasswordResetView();
                break;
            case AccountModule.MODE_PASSWORD_RESET_SUCCESS:
                viewNodes = renderPasswordResetSuccessView();
                break;
            case AccountModule.MODE_EMAIL_VERIFICATION:
                viewNodes = renderEmailVerificationView();
                break;
            case AccountModule.MODE_EMAIL_VERIFICATION_SUCCESS:
                viewNodes = renderEmailVerificationSuccessView();
                break;
            case AccountModule.MODE_ACCOUNT_DETAILS:
                viewNodes = renderAccountDetailsView();
                break;
            default:
                viewNodes = renderRegistrationView();
                break;
        }

        return ct.module([
            ct.space(),
            ct.card('.large-width.auto-horizontal-margin', ct.concat(
                viewNodes
            )),
        ]);

        // ----------

        function renderRegistrationView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [

                ct.section([
                    ct.h1([
                        i18n.t('module.account.title_registration')
                    ]),
                    ct.grid([
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.username.label')),
                                ct.textBox(module.registerData.username, {
                                    onchange: function (e) {
                                        module.registerData.username = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ])
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.email.label')),
                                ct.textBox(module.registerData.email, {
                                    onchange: function (e) {
                                        module.registerData.email = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.password.label')),
                                ct.textBox(module.registerData.password, {
                                    type: 'password',
                                    onchange: function (e) {
                                        module.registerData.password = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.password_verification.label')),
                                ct.textBox(module.registerData.passwordVerification, {
                                    type: 'password',
                                    onchange: function (e) {
                                        module.registerData.passwordVerification = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(6), [
                            ct.field([
                                ct.label(i18n.t('field.first_name.label')),
                                ct.textBox(module.registerData.firstName, {
                                    onchange: function (e) {
                                        module.registerData.firstName = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(6), [
                            ct.field([
                                ct.label(i18n.t('field.last_name.label')),
                                ct.textBox(module.registerData.lastName, {
                                    onchange: function (e) {
                                        module.registerData.lastName = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                    ]),
                    ct.nav([
                        ct.textButton(i18n.t('button.register.label'), {
                            disabled: !module.isRegisterDataValid(),
                            onclick: function (e) {
                                module.registerUser();
                            }
                        }),
                    ])
                ]),

                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.lbl_back_to_login_page'),
                    ]),
                ]),

            ];

        };

        function renderRegistrationSuccessView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [
                ct.section([

                    ct.h1([
                        i18n.t('module.account.registration_title')
                    ]),
                    ct.p([
                        i18n.t('module.account.registration_success')
                    ]),
                    ct.p([
                        i18n.t('module.account.registration_success_msg')
                    ]),
                ]),
                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.msg_proceed_to_login_page'),
                    ]),
                ]),
            ];

        };

        function renderEmailVerificationView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [

                ct.section([

                    ct.h1([
                        i18n.t('module.account.registration_title')
                    ]),
                    ct.p([
                        i18n.t('module.account.registration_email_verification_msg')
                    ]),
                    ct.grid([
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.verification_code.label')),
                                ct.textBox(module.emailVerificationData.code, {
                                    type: 'text',
                                    onkeyup: function (e) {
                                        module.emailVerificationData.text = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                    ]),
                    ct.nav([
                        ct.textButton(i18n.t('module.account.btn_verify'), {
                            disabled: !module.isEmailVerificationDataValid(),
                            onclick: function (e) {
                                module.verifyEmail();
                            }
                        }),
                    ]),
                ]),

                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.msg_proceed_to_login_page'),
                    ]),
                ]),
            ];

        };

        function renderEmailVerificationSuccessView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [
                ct.section([
                    ct.h1([
                        i18n.t('module.account.registration_title')
                    ]),
                    ct.p([
                        i18n.t('module.account.registration_email_verification_sucess')
                    ]),
                    ct.p([
                        i18n.t('module.account.registration_email_verification_success_msg')
                    ]),
                ]),
                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.msg_proceed_to_login_page'),
                    ]),
                ]),
            ];

        };

        // ----------

        function renderPasswordResetStartView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [
                ct.section([
                    ct.h1([
                        i18n.t('module.account.password_reset_title')
                    ]),
                    ct.p(ct.w(12), [
                        i18n.t('module.account.password_reset_start_instructions')
                    ]),
                    ct.grid([
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.email.label')),
                                ct.textBox(module.passwordResetStartData.email, {
                                    onkeyup: function (e) {
                                        module.passwordResetStartData.email = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                    ]),
                    ct.nav([
                        ct.textButton(i18n.t('module.account.btn_reset_password'), {
                            disabled: !module.isPasswordResetStartDataValid(),
                            onclick: function (e) {
                                module.startPasswordReset();
                            }
                        }),
                    ]),
                ]),
                ct.p([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.lbl_back_to_login_page'),
                    ]),
                ]),
            ];

        };

        function renderPasswordResetStartSuccessView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [
                ct.section([
                    ct.h1([
                        i18n.t('module.account.password_reset_title')
                    ]),
                    ct.p([
                        i18n.t('module.account.password_reset_start_success')
                    ]),
                    ct.p([
                        i18n.t('module.account.password_reset_start_success_instructions')
                    ]),
                ]),
                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.lbl_back_to_login_page'),
                    ]),
                ]),
            ];
        };

        function renderPasswordResetView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [
                ct.section([
                    ct.h1([
                        i18n.t('module.account.password_reset_title'),
                    ]),
                    ct.p([
                        i18n.t('module.account.password_reset_instructions')
                    ]),
                    ct.grid([
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.verification_code.label')),
                                ct.textBox(module.passwordResetData.code, {
                                    type: 'text',
                                    onkeyup: function (e) {
                                        module.passwordResetData.text = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.password.label')),
                                ct.textBox(module.passwordResetData.password, {
                                    type: 'password',
                                    onkeyup: function (e) {
                                        module.passwordResetData.password = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.password_verification.label')),
                                ct.textBox(module.passwordResetData.passwordVerification, {
                                    type: 'password',
                                    onkeyup: function (e) {
                                        module.passwordResetData.passwordVerification = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                    ]),
                    ct.nav([
                        ct.textButton(i18n.t('module.account.btn_reset_password'), {
                            disabled: !module.isPasswordResetDataValid(),
                            onclick: function (e) {
                                module.resetPassword();
                            }
                        })
                    ]),
                ]),
                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.lbl_back_to_login_page'),
                    ]),
                ]),
            ];

        };

        function renderPasswordResetSuccessView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [
                ct.section([
                    ct.h1([
                        i18n.t('module.account.password_reset_title')
                    ]),
                    ct.p([
                        i18n.t('module.account.password_reset_success')
                    ]),
                    ct.p([
                        i18n.t('module.account.password_reset_success_msg')
                    ]),
                ]),
                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.lbl_back_to_login_page'),
                    ]),
                ]),
            ];
        };

        // ----------

        function renderAccountDetailsView() {

            const app = module.getApp(),
                loginUrl = app.getRouteHash('auth-login');

            return [
                ct.section([
                    ct.h1([
                        i18n.t('module.account.title_account_details'),
                    ]),
                    ct.grid([
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.username.label')),
                                ct.textBox(module.userData.username, {
                                    readonly: '',
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.email.label')),
                                ct.textBox(module.userData.email, {
                                    readonly: '',
                                }),
                            ]),
                        ]),
                    ]),
                    ct.h1([
                        i18n.t('module.account.title_personal_information'),
                    ]),
                    ct.grid([
                        ct.cell(ct.w(6), [
                            ct.field([
                                ct.label(i18n.t('field.first_name.label')),
                                ct.textBox(module.accountData.firstName, {
                                    onkeyup: function (e) {
                                        module.accountData.firstName = e.target.value;
                                        module.accountData.$changed = true;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(6), [
                            ct.field([
                                ct.label(i18n.t('field.last_name.label')),
                                ct.textBox(module.accountData.lastName, {
                                    onkeyup: function (e) {
                                        module.accountData.lastName = e.target.value;
                                        module.accountData.$changed = true;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                    ]),
                    ct.nav([
                        ct.textButton(i18n.t('button.save.label'), {
                            disabled: !module.isAccountDataValid(),
                            onclick: function (e) {
                                module.changeDetails();
                            }
                        }),
                    ]),
                    ct.h1([
                        i18n.t('module.account.title_password_change'),
                    ]),
                    ct.grid([
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.actual_password.label')),
                                ct.textBox(module.passwordChangeData.actualPassword, {
                                    type: 'password',
                                    onkeyup: function (e) {
                                        module.passwordChangeData.actualPassword = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.new_password.label')),
                                ct.textBox(module.passwordChangeData.password, {
                                    type: 'password',
                                    onkeyup: function (e) {
                                        module.passwordChangeData.password = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                        ct.cell(ct.w(12), [
                            ct.field([
                                ct.label(i18n.t('field.new_password_verification.label')),
                                ct.textBox(module.passwordChangeData.passwordVerification, {
                                    type: 'password',
                                    onkeyup: function (e) {
                                        module.passwordChangeData.passwordVerification = e.target.value;
                                        module.invalidate();
                                    }
                                }),
                            ]),
                        ]),
                    ]),
                    ct.nav([
                        ct.textButton(i18n.t('module.account.btn_change_password'), {
                            disabled: !module.isPasswordChangeDataValid(),
                            onclick: function (e) {
                                module.changePassword();
                            }
                        }),
                    ]),
                ]),
                ct.section([
                    ct.link(loginUrl, '.button.outlined', [
                        i18n.t('module.account.lbl_back_to_login_page'),
                    ]),
                ]),
            ];

        };

    };

};